import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=aa5c4fca&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=ts"
export * from "./Overview.vue?vue&type=script&lang=ts"
import style0 from "./Overview.vue?vue&type=style&index=0&id=aa5c4fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5c4fca",
  null
  
)

export default component.exports